import { render, staticRenderFns } from "./mobileAtlas.vue?vue&type=template&id=7a2a95ff&scoped=true&"
import script from "./mobileAtlas.vue?vue&type=script&lang=js&"
export * from "./mobileAtlas.vue?vue&type=script&lang=js&"
import style0 from "./mobileAtlas.vue?vue&type=style&index=0&id=7a2a95ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a95ff",
  null
  
)

export default component.exports